import * as $ from 'jquery';
import 'slick-carousel';

const surgeriesCarousel = (selector: string) => {
	$(function () {
		$(selector).slick({
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			autoplay: true,
			autoplaySpeed: 5000,
			speed: 500,
			draggable: true,
			fade: true,
			cssEase: 'linear',
			dots: true,
			infinite: true,
			pauseOnHover: false,
			nextArrow: '<button type="button" class="slick-control slick-next" title="Next"><span>Next</span><svg xmlns="http://www.w3.org/2000/svg" width="27.922" height="20.558" viewBox="0 0 27.922 20.558"><g id="Group_3697" data-name="Group 3697" transform="translate(-145.906 -1215.752)"><path id="Path_2522" data-name="Path 2522" d="M-19799.094-18230h23.777" transform="translate(19946 19456.016)" fill="none" stroke="#9a51db" stroke-linecap="round" stroke-width="2"/><path id="Path_2523" data-name="Path 2523" d="M152.635,1217.838l8.865,8.865-8.865,8.865" transform="translate(11.329 -0.672)" fill="none" stroke="#9a51db" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg></button>',
			prevArrow: '<button type="button" class="slick-control slick-prev" title="Previous"><svg xmlns="http://www.w3.org/2000/svg" width="27.922" height="20.558" viewBox="0 0 27.922 20.558"><g id="Group_4256" data-name="Group 4256" transform="translate(173.828 1236.309) rotate(180)"><path id="Path_2522" data-name="Path 2522" d="M-19799.094-18230h23.777" transform="translate(19946 19456.016)" fill="none" stroke="#9a51db" stroke-linecap="round" stroke-width="2"/><path id="Path_2523" data-name="Path 2523" d="M152.635,1217.838l8.865,8.865-8.865,8.865" transform="translate(11.329 -0.672)" fill="none" stroke="#9a51db" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/></g></svg><span>Previous</span></button>',
			responsive: [
				{ breakpoint: 900, settings: { slidesToShow: 1, slidesToScroll: 1 } }
			],
			customPaging: function(slick,index) {
				var targetImage = slick.$slides.eq(index).find('img').attr('src');
				return '<button><img src=" ' + targetImage + ' "/></button>';
			},
			appendDots: $('.custom-slick-dots'),
			appendArrows: $('.custom-slick-arrows')

		});
	});
};

export default surgeriesCarousel;